import { Partners } from '@mesa-labs/mesa-api/dist/types';
import { useLocation } from 'react-router-dom';

import { useGetProgramsQuery } from '../redux/api/vendor';
import { useSelector } from '../redux/hooks';

// Every payment schedule step builds its fee table from getPrograms, and the table is
// absent until it resolves. Holding one subscription for the whole onboarding flow keeps
// the cache warm, so those steps render their table immediately.
function usePreloadPrograms(): void {
  const { pathname } = useLocation();
  const partnerId = useSelector((state) => state.onboarding.partnerId);
  const promoCode = useSelector((state) => state.onboarding.promoCode);

  useGetProgramsQuery(
    { partner: partnerId || Partners.JLL, promoCode: promoCode || undefined },
    { skip: !pathname.startsWith('/onboarding/') },
  );
}

export default usePreloadPrograms;
